import { render, staticRenderFns } from "./TransactionCommonForm.vue?vue&type=template&id=9189c314&scoped=true&"
import script from "./TransactionCommonForm.vue?vue&type=script&lang=js&"
export * from "./TransactionCommonForm.vue?vue&type=script&lang=js&"
import style0 from "./TransactionCommonForm.vue?vue&type=style&index=0&id=9189c314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9189c314",
  null
  
)

export default component.exports